import { render, staticRenderFns } from "./ConfirmModalLote.vue?vue&type=template&id=18b5dbe3&"
import script from "./ConfirmModalLote.vue?vue&type=script&lang=js&"
export * from "./ConfirmModalLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports